import axios from 'axios';
import { push } from 'connected-react-router';

import {
  API_URL,
  JWT_TOKEN,
  USER_FULL_NAME,
  LOGGED_IN_USER,
  PERMISSION_KEY,
  MENU_KEY,
  LANGUAGE_KEY,
  ENFORCE_TYPE,
  LOGO_URL,
  SMALL_LOGO_URL,
  USER_ID,
  OTP_TOKEN,
  ENFORCE_PASSWORD_CHANGE,
} from '../constants/appConfig';
import { http404Error, http500Error } from '../actions/httpErrorAction';
import configureStore from '../store/configureStore';
import { getLocalStorage, setLocalStorage, clearLocalStorage } from './storageUtil';
import history from './history';
import { isRestoreActive } from './restoreRegistry';

const store = configureStore();

const isUnfilteredListMountFetch = data => {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return false;
  const keys = Object.keys(data);
  if (keys.length === 0) return true;
  const looksLikeListFetch = 'pageNumber' in data || 'pageSize' in data;
  if (!looksLikeListFetch) return false;
  return !keys.some(k => Array.isArray(data[k]) && data[k].length > 0);
};

export const httpBase = (isDownloadable = false, cancelToken) => {
  const headers = {
    'X-XSRF-TOKEN': getLocalStorage(JWT_TOKEN),
    Lang: getLocalStorage(LANGUAGE_KEY) ? getLocalStorage(LANGUAGE_KEY) : 'en',
  };
  const normalHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  const downloadableHeaders = {
    Accept: '*/*',
    'Content-Type': 'application/json',
  };

  const api = axios.create({
    baseURL: `${API_URL}`,
    headers: isDownloadable
      ? { ...headers, ...downloadableHeaders }
      : { ...headers, ...normalHeaders },
    responseType: isDownloadable ? 'blob' : 'json',
    cancelToken: cancelToken || undefined,
  });

  api.interceptors.request.use(config => {
    if (config.method === 'post' && isRestoreActive() && isUnfilteredListMountFetch(config.data)) {
      return Promise.reject({ __restoreShortCircuit: true, config });
    }
    return config;
  });

  api.interceptors.response.use(
    response => {
      if (response.headers && response.headers['x-xsrf-token']) {
        setLocalStorage(JWT_TOKEN, response.headers['x-xsrf-token']);
      }
      return response;
    },
    error => {
      if (error && error.__restoreShortCircuit) {
        return Promise.resolve({ data: { message: 'CANCELLED_FOR_RESTORE' } });
      }
      if (error?.response?.status === 401) {
        clearLocalStorage(JWT_TOKEN);
        clearLocalStorage(USER_FULL_NAME);
        clearLocalStorage(LOGGED_IN_USER);
        clearLocalStorage(PERMISSION_KEY);
        clearLocalStorage(MENU_KEY);

        history.push('/');
      }

      return Promise.reject(error);
    }
  );

  return api;
};
